
import  request  from '../../Interceptor/request.js'

//故障上报
export function badInfo(data) {
    return request({
        url: '/faultReport',
        method: 'post',
        data:data
    })
}
